module.exports = __webpack_public_path__ + "static/img/08013B_3_4_R_20220630_fit.958659f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08013B_3_4_R_20220630_fit.png
// module id = yjQY
// module chunks = 0